module.exports = __webpack_public_path__ + "static/media/local-community-occasion-grid-2.d2681ee6.jpg";